<template>
</template>

<script>
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import Toast, {ToastService} from '../../../common/Toast';

Vue.use(VueToast);


export default {
    computed: {
        toastConfig() {
            return {
                position: 'top-right',
                tapToDismiss: false,
                animation: 'none',
                bodyOutputType: 'TrustedHtml'
            }
        }
    },
    beforeMount() {
        Toast.init();
        ToastService.$on('showToast', (option) => {
            this.showToast(option);
        })
    },
    methods: {
        showToast(option) {
            Vue.$toast.open({
                ...option,
                position: 'top-right'
            });
        }
    }
}

</script>

<style scoped lang="scss">


</style>
